import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal } from 'semantic-ui-react';
import { Translate } from 'react-redux-i18n';
import { useAppDispatch } from '../../../hooks';
import { RootState } from '../../../store';
import { deleteAccessKey, hideDisableConfirmation } from '../store/accessKeyActions';
import { IAccessKeyElementModel, maskClientKey } from '../../../models/AccessKey';

interface Props {
  accessKey: IAccessKeyElementModel;
}

// Modal relies purely on Redux flags; no parent setState toggling.
export const DisableAccessKeyModal = ({ accessKey }: Props) => {
  const dispatch = useAppDispatch();
  const accessKeyReducer = useSelector((s: RootState) => (s as any).accessKey);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false); // track if this modal initiated a delete
  const isOpen = !!accessKeyReducer.showDisableConfirmation;

  const close = () => dispatch(hideDisableConfirmation() as any);

  const onConfirm = () => {
    setLoading(true);
    setSubmitted(true);
    const id = (accessKey as any)?.id;
    dispatch(deleteAccessKey(id) as any);
  };

  useEffect(() => {
    // Only auto-close when this instance triggered a delete (submitted)
    if (!submitted) return;
    const r = accessKeyReducer.record;
    if (r.ready === -1 || r.error) {
      close();
      setLoading(false);
      setSubmitted(false);
    }
  }, [accessKeyReducer, accessKeyReducer.record.error]);

  return (
    <Modal open={isOpen} onClose={close}>
      <Modal.Content>
        <h1>
          <Translate value={'accessKeys.page.disable-modal.title'} />
        </h1>
        <p>
          <b><Translate value={'accessKeys.page.disable-modal.description-label'} /></b>{accessKey.description}
        </p>
        <p>
          <b><Translate value={'accessKeys.page.disable-modal.clientKey'} /></b>{maskClientKey(accessKey.clientKey)}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button disabled={loading} onClick={close}>
          <Translate value={'accessKeys.page.disable-modal.cancel'} />
        </Button>
        <Button className="red" loading={loading} onClick={onConfirm}>
          <Translate value={'accessKeys.page.disable-modal.disable'} />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
